import Big from 'big.js'
import { useTranslations, useFormatter, useLocale } from 'next-intl'
import { sanitizeCurrencyCode } from '~/utils/formatAmount'

const hasDecimals = (number: number) => number % 1 !== 0

export const usePricingMessageFormatters = () => {
  const t = useTranslations('common.pricing.formatters')
  const format = useFormatter()
  const locale = useLocale()

  return {
    // Spanish's default grouping omits the separator for four-digit amounts.
    formatAvios: (value: number) =>
      format.number(value, locale === 'es-ES' ? { useGrouping: true } : undefined),
    addAviosLabel: (avios: string) => t('avios_with_label', { avios }),
    formatCash: (cash: Big | number, currency: string) => {
      const n = cash instanceof Big ? cash.round(2, Big.roundUp).toNumber() : cash
      return format.number(n, {
        style: 'currency',
        currency: sanitizeCurrencyCode(currency),
        currencyDisplay: 'symbol',
        minimumFractionDigits: hasDecimals(n) ? 2 : 0,
      })
    },
    formatAndRoundCash: (cash: Big | number, currency: string) => {
      const n = cash instanceof Big ? cash.round(2, Big.roundUp).toNumber() : cash
      return format.number(n, {
        style: 'currency',
        currency: sanitizeCurrencyCode(currency),
        currencyDisplay: 'symbol',
        maximumFractionDigits: 0,
      })
    },
    formatAgeGroupCount: (ageGroup: string, count: number) =>
      t('format_age_group_count', { ageGroup, count }),
  }
}
